import * as React from "react";
import { strings } from "../../../../localisation";
import { EmailListSpan, FirstEmailOnlySpan } from "./EmailList.styles";

export interface IEmailListProps {
    AddressTypes?: string[];
    FirstEmailOnly: boolean;
    RecipientCount: number;
}

export const EmailList: React.FunctionComponent<IEmailListProps> = ({ AddressTypes, FirstEmailOnly, RecipientCount }: IEmailListProps) => {
    return (
        <EmailListSpan>
            {AddressTypes && <> {AddressTypes.join(", ")} </>}
            <FirstEmailOnlySpan>
                {FirstEmailOnly
                    ? strings.Label_Summary_FirstEmail
                    : RecipientCount > 0
                        ? strings.formatString(strings.Label_Summary_SendToCount, RecipientCount)
                        : ""
                }
            </FirstEmailOnlySpan>
        </EmailListSpan>
    );
};
